import React, { memo } from "react";

const TestProgress = memo(function TestProgress({
  mockData,
  questions,
  currentQuestion,
  pending,
  localPending,
  skip
}) {

  
  const currentQuestionNumber = () => {
    if(localPending == 1)
    {
      return currentQuestion + mockData?.curr_q + 1;
    }
    return currentQuestion + 1;
  };

  const totalQuestions = () => {
    if(localPending == 1)
    {
      return questions?.length + (mockData?.curr_q || 0);
    }
    return questions?.length;
  };


  console.log("PENDING",pending);
  
  console.log("current Question---",mockData.curr_q);
  console.log("mockData.q_count",mockData?.q_count);
  console.log("questions?.length",questions?.length);

  return (
    <div className="item">
      <p>
        Question {currentQuestionNumber()} of {totalQuestions()}
          {/* Question {currentQuestion + mockData?.q_count + 1} off {questions?.length + mockData?.q_count} */}
      </p>
    </div>
  );
});

export default TestProgress;
